import { render, staticRenderFns } from "./IndexItem.vue?vue&type=template&id=24c2ecc6"
import script from "./IndexItem.vue?vue&type=script&lang=js"
export * from "./IndexItem.vue?vue&type=script&lang=js"
import style0 from "./IndexItem.vue?vue&type=style&index=0&id=24c2ecc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports